import { render, staticRenderFns } from "./forexView.vue?vue&type=template&id=306e737c&scoped=true"
import script from "./forexView.vue?vue&type=script&lang=js"
export * from "./forexView.vue?vue&type=script&lang=js"
import style0 from "./forexView.vue?vue&type=style&index=0&id=306e737c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306e737c",
  null
  
)

export default component.exports